<script setup lang="ts">
/**
 * Full-row cell for the mobile booking types list.
 */
defineProps<{
  name?: string
  description?: string
  address?: string
}>()
</script>

<template>
  <td class="bt-mobile-cell font-tufte text-tufte-text">
    <div class="row-layout">
      <div class="row-main">
        <span class="row-name">{{ name }}</span>
        <span v-if="description" class="row-desc text-tufte-muted">{{ description }}</span>
        <span v-else-if="address" class="row-desc text-tufte-muted">{{ address }}</span>
      </div>
      <span class="chev" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M9 6l6 6-6 6" />
        </svg>
      </span>
    </div>
  </td>
</template>

<style scoped>
.bt-mobile-cell {
  vertical-align: top;
}

.row-layout {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
}

.row-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.row-name {
  font-size: var(--text-tufte-lg);
  font-weight: 500;
  line-height: 1.25;
}

.row-desc {
  font-family: var(--font-tufte-sans);
  font-size: var(--text-tufte-sm);
  line-height: 1.4;
}

.chev {
  flex-shrink: 0;
  color: var(--color-tufte-border);
  padding-top: 0.35rem;
}

.chev svg {
  display: block;
  width: 0.85rem;
  height: 0.85rem;
}
</style>
